import { Route, Switch } from "react-router-dom";
import { AcceptInvite } from "./AcceptInvite/AcceptInvite";
import useStyles from "./InviteHome.styles";

export const InviteHome = () => {
  const classes = useStyles();

  return (
    <div className={classes.view}>
      <div className={classes.body}>
        <div className={classes.content}>
          <Switch>
            <Route>
              <AcceptInvite />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};
